<template>
  <v-container>
    <v-card class="pa-4">
      <v-card-title class="text-h5">Profile Details</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="submitProfile">
          <v-row>
            <!-- First Name -->
            <v-col cols="12" md="4">
              <v-text-field v-model="profileStore.ProfileData.first_name" label="First Name" outlined
                dense></v-text-field>
              <!-- <v-text-field v-model="profile.firstName" label="First Name" outlined dense></v-text-field> -->
            </v-col>

            <!-- Middle Name -->
            <!-- <v-col cols="12" md="4">
                <v-text-field v-model="profile.middleName" label="Middle Name" outlined dense></v-text-field>
              </v-col> -->
            <!-- Last Name -->
            <v-col cols="12" md="4">
              <v-text-field v-model="profileStore.ProfileData.last_name" label="Last Name" outlined
                dense></v-text-field>
            </v-col>
            <!-- Phone Number -->
            <v-col cols="12" md="4">
                <v-text-field v-model="profileStore.ProfileData.contact" label="Contact" outlined dense></v-text-field>
              </v-col>

            <!-- Date of Birth -->
            <v-col cols="12" md="4">
              <v-text-field v-model="profileStore.ProfileData.email" label="Email" type="email" outlined
                dense></v-text-field>
            </v-col>

            <!-- Gender -->
            <!-- <v-col cols="12" md="4">
                <v-select v-model="profile.gender" :items="['Male', 'Female', 'Other']" label="Gender" outlined dense></v-select>
              </v-col> -->

            <!-- Address -->
            <!-- <v-col cols="4">
                <v-text-field v-model="profileStore.ProfileData.role" label="Role" outlined dense></v-text-field>
              </v-col> -->
          </v-row>

          <v-row>
            <!-- Save Button -->
            <v-col cols="3">
              <v-btn color="primary" class="mt-3" type="submit" block>Update Profile</v-btn>
            </v-col>
            <!-- Discard Button -->
            <!-- <v-col cols="3">
              <v-btn color="error" @click="discardChanges" class="mt-3" block>Discard Changes</v-btn>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { computed, onMounted } from "vue";

import { useProfileStore } from "@/Store/profileStore";
const profileStore = useProfileStore();

const profile = computed(() => profileStore.ProfileData);

const submitProfile = () => {
  profileStore.updateProfileData(profile.value);
}
// const discardChanges = () => {
//   Object.assign(profile, { ...profile });
//   // alert("Changes discarded!");
// };


onMounted(async () => {
  await profileStore.fetchProfileData();
});

</script>

<style scoped>
/* Clean up the UI by removing unnecessary margins and making the form more compact */
.v-card {
  /* max-width: 800px; */
  margin: 0 auto;
}

.v-btn {
  font-weight: 500;
}

/* Make form elements look cleaner with tighter padding */
.v-text-field,
.v-select,
.v-textarea {
  margin-bottom: 16px;
}
</style>